import { ControlledMenu } from '@szhsin/react-menu';
import { GridContextMenuProps } from '../../../helpers/contextMenu/prepareContextMenu';
import { MenuSearchInput, MenuView } from './MenuAtoms';
import useGridContextMenu from './useGridContextMenu';

const GridContextMenu: React.FC<GridContextMenuProps> = (props) => {
  const { menuSets, searchText, setSearchText } = useGridContextMenu(props);

  const position = { x: props.contextMenuState.x, y: props.contextMenuState.y };
  return (
    <ControlledMenu
      {...props.menuState}
      anchorPoint={position}
      onClose={props.closeContextMenu}
      overflow="auto"
      onWheel={(e) => {
        e.stopPropagation();
      }}
      unmountOnClose={true}
      menuStyle={{
        background: props.fill,
        color: props.textColor,
      }}
      menuItemFocus={{
        position: 'first',
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        if (e.key !== 'Escape') e.stopPropagation();
      }}
      portal={true}
    >
      <MenuSearchInput value={searchText} onChange={setSearchText} />
      <MenuView
        menuSets={menuSets}
        background={props.fill}
        onClose={props.closeContextMenu}
      />
    </ControlledMenu>
  );
};

export default GridContextMenu;
